import React from 'react'
import { FileList } from '@pandiafi/components'

import { BulletinType } from '../../../../../common/validations'
import { AttachmentLink } from './components/AttachmentLink/AttachmentLink'
import { AttachmentLinkErrorHandler } from './components/AttachmentLink/AttachmentLinkErrorHandler'

interface BulletinAttachmentsProps {
  attachments: BulletinType['attachments']
}

export const BulletinAttachments: React.FC<BulletinAttachmentsProps> = ({
  attachments,
}) => {
  if (!attachments) {
    return null
  }

  return (
    <FileList className="mt-10 w-full">
      {attachments.map((attachment) => (
        <AttachmentLinkErrorHandler key={attachment.uuid}>
          <AttachmentLink attachment={attachment} />
        </AttachmentLinkErrorHandler>
      ))}
    </FileList>
  )
}
